// Todo : Get limits from backend(email-account/esp-limits)
export const resetToDefaultSendingLimits = {
  outreachDefault: 15,
  inboxPlacementDefault: 5,
};

export const defaultTimeInterval = {
  minInterval: 300,
  maxInterval: 1200,
};
